import { BackDropQueue } from 'queue'
import { useEffect, useState } from 'react'
import { map } from 'rxjs'

function useBackDrop() {
  const [backdropOpen, setBackdropOpen] = useState<boolean>(false)

  useEffect(() => {
    const val$ = BackDropQueue.getValue()
      .pipe(map((value: boolean) => setBackdropOpen(value)))
      .subscribe()

    return () => val$.unsubscribe()
  }, [])

  return backdropOpen
}

export default useBackDrop
